import * as API from './API'

export default {

    async getHomeBanners() {
        let parameters = {
            method: 'GET',
            path: '/p/api/main/banner',
            params: {}
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async getHomeJobs() {
        let parameters = {
            method: 'GET',
            path: '/p/api/main/work',
            params: {}
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async getNoticeList(page, size) {
        let parameters = {
            method: 'GET',
            path: '/p/api/notices',
            params: {
                'page': page,
                'size': size
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async getNoticeDetail(uuid) {
        let parameters = {
            method: 'GET',
            path: '/p/api/notices/' + uuid,
        }

        const apiResponse = await API.request(parameters)
        return apiResponse
    }

}



// WEBPACK FOOTER //
// ./src/service/contentAPI.js